module.exports = __webpack_public_path__ + "static/media/es.e511dcee.svg";